import React, { Component } from 'react';
import './App.css';
import Header from './Header';
import styled from 'styled-components';
import Footer from './Footer';
import ContactFloater from './Components/ContactFloater';

const Container = styled.div`

padding:0;
    `;
function App() {
    
  return (
    <div className="App">
      <Container>
        <Header />
        <Footer />
        <ContactFloater />
      </Container>
    </div>
  );
}


export default App;

